import styled from "styled-components";

export const RegisterFromWrapper=styled.div`
  h1{
    text-align:center;
    margin-top:30px;
    color:#654E92;
  }
  .link{
    text-align:center;

  }
`